import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ANIMATION_DURATION } from './animation-schedule-constants';
import { useAnimationSchedule, useRevealBoundary } from './animation-schedule-context';

import './text-chunk-animation.scss';

export function TextChunkAnimation({ children = null, unitId, blocksFollowing = false }) {
  const { requestAnimation } = useAnimationSchedule();
  const { reportRevealLeaf } = useRevealBoundary();
  const [animation] = useState(() => requestAnimation(unitId, { duration: ANIMATION_DURATION, blocksFollowing }));
  const handleAnimationStart = useCallback(event => reportRevealLeaf(event.currentTarget), [reportRevealLeaf]);

  return (
    <span
      onAnimationStart={handleAnimationStart}
      className="text-chunk-animation d-inline-block"
      style={{ '--delay': `${animation.delay}ms` }}
    >
      {children}
    </span>
  );
}

TextChunkAnimation.propTypes = {
  children: PropTypes.node,
  unitId: PropTypes.string.isRequired,
  blocksFollowing: PropTypes.bool,
};
